import { FormControl, ValidationErrors } from "@angular/forms";
import dayjs from "@webapp/shared/libs/dayjs";
import { CHART_NUMBER_OF_ACCESSIBLE_YEAR_IN_FUTURE } from "./components/kpi-details/kpi-chart/utils";

export const MAX_KPI_FRACTION_SIZE = 5;

export function dateValidator(control: FormControl): ValidationErrors {
  if (isDateAfterAllowedAccessibleFutureDate(control.value)) {
    return { dateIsInvalid: true };
  }

  return null;
}

export function isDateAfterAllowedAccessibleFutureDate(date: Date): boolean {
  return dayjs(date).isAfter(dayjs().add(CHART_NUMBER_OF_ACCESSIBLE_YEAR_IN_FUTURE, "years"));
}
